<template>
  <div class="py-5 container-fluid">
    <div id="topinfo">
      <div class="row mt-4 justify-content-center">
        <div class="col-12">
          <div class="mx-auto mx-auto col-xl-9 col-lg-10 col-md-11 col-sm-12 text-start mt-3 mb-0">
            <button
              class="btn btn-outline-secondary btn-sm px-3 mt-1 mb-3"
              @click="$router.push({ name: 'SteelCase' })"
            >
              <font-awesome-icon :icon="['fas', 'arrow-rotate-left']" />
              Go back to line list
            </button>
          </div>
          <div class="mx-auto col-xl-8 col-lg-9 col-md-10 d-flex mb-2 flex-column card card-body blur shadow-blur">
            <div class="card-header text-center">
              <h3 class="font-weight-bolder text-success text-gradient">Line Detail</h3>
              <h5
                v-if="coating_booth"
                class="mb-0"
              >
                for Line <i>{{ coating_booth.name }}</i>
              </h5>
            </div>
          </div>
          <div class="mx-auto col-xl-8 col-lg-9 col-md-10 d-flex flex-column">
            <div class="row my-4">
              <div class="multisteps-form mt-3">
                <div class="multisteps-form__progress">
                  <button
                    v-if="reciprocators.side_A"
                    class="multisteps-form__progress-btn"
                    type="button"
                    :class="currentPage == 0 ? 'js-active position-relative' : ''"
                    @click="currentPage = 0"
                  >
                    {{ reciprocators.side_A.name }}
                  </button>
                  <button
                    v-if="reciprocators.side_B"
                    class="multisteps-form__progress-btn"
                    type="button"
                    :class="currentPage == 1 ? 'js-active position-relative' : ''"
                    @click="currentPage = 1"
                  >
                    {{ reciprocators.side_B.name }}
                  </button>
                  <button
                    v-if="reciprocators.side_bottom"
                    class="multisteps-form__progress-btn"
                    type="button"
                    :class="currentPage == 2 ? 'js-active position-relative' : ''"
                    @click="currentPage = 2"
                  >
                    {{ reciprocators.side_bottom.name }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="currentPage === 0"
            class="mx-auto col-xl-9 col-lg-10 col-md-11 col-sm-12 d-flex flex-column card card-body blur shadow-blur"
          >
            <div
              class="card-body mb-0 pb-3"
              style="padding-top: 0.5rem"
            >
              <div class="row">
                <h5 class="mt-2">Line Layout</h5>
                <div class="d-flex justify-content-center">
                  <canvas
                    :id="LINE_LAYOUT_CANVAS_ID_A"
                    class="col-12 mt-0 mb-4"
                    :width="CANVAS_WIDTH"
                    :height="CANVAS_HEIGHT"
                    :style="`max-width: 1280px;`"
                  >
                  </canvas>
                </div>
              </div>
              <div
                class="row"
                v-if="reciprocators.side_A"
              >
                <div class="d-flex justify-content-center">
                  <div
                    class="table-responsive"
                    style="max-width: 1280px; width: 90%"
                  >
                    <table class="table table-sm text-center">
                      <thead>
                        <tr>
                          <th>Gun Name</th>
                          <th>New Gun Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="gun in reciprocators.side_A.guns"
                          :key="gun.gun_index"
                        >
                          <td>
                            {{ gun.name }}
                          </td>
                          <td>
                            <input
                              v-model="gun.gun_name_user_input"
                              type="text"
                              class="form-control form-control-sm mx-auto"
                              style="width: 50%"
                              @blur="checkGunNameLength(gun.gun_name_user_input)"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="col-12 d-flex justify-content-center mt-4">
                <button
                  type="button"
                  class="mt-4 mb-2 text-center btn"
                  :class="currentGunNamesFormUpdated ? 'bg-gradient-success' : 'bg-gradient-secondary'"
                  style="width: 50%"
                  @click="saveNewNames(reciprocators.side_A)"
                >
                  Save changes
                </button>
              </div>
            </div>
          </div>
          <div
            v-if="currentPage === 1"
            class="mx-auto col-xl-9 col-lg-10 col-md-11 col-sm-12 d-flex flex-column card card-body blur shadow-blur"
          >
            <div
              class="card-body mb-0 pb-3"
              style="padding-top: 0.5rem"
            >
              <div class="row">
                <h5 class="mt-2">Line Layout</h5>
                <div class="d-flex justify-content-center">
                  <canvas
                    :id="LINE_LAYOUT_CANVAS_ID_B"
                    class="col-12 mt-0 mb-4"
                    :width="CANVAS_WIDTH"
                    :height="CANVAS_HEIGHT"
                    :style="`max-width: 1280px;`"
                  >
                  </canvas>
                </div>
              </div>
              <div
                class="row"
                v-if="reciprocators.side_B"
              >
                <div class="d-flex justify-content-center">
                  <div
                    class="table-responsive"
                    style="max-width: 1280px; width: 90%"
                  >
                    <table class="table table-sm text-center">
                      <thead>
                        <tr>
                          <th>Gun Name</th>
                          <th>New Gun Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="gun in reciprocators.side_B.guns"
                          :key="gun.gun_index"
                        >
                          <td>
                            {{ gun.name }}
                          </td>
                          <td>
                            <input
                              v-model="gun.gun_name_user_input"
                              type="text"
                              class="form-control form-control-sm mx-auto"
                              style="width: 50%"
                              @blur="checkGunNameLength(gun.gun_name_user_input)"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="col-12 d-flex justify-content-center mt-4">
                <button
                  type="button"
                  class="mt-4 mb-2 text-center btn"
                  :class="currentGunNamesFormUpdated ? 'bg-gradient-success' : 'bg-gradient-secondary'"
                  style="width: 50%"
                  @click="saveNewNames(reciprocators.side_B)"
                >
                  Save changes
                </button>
              </div>
            </div>
          </div>
          <div
            v-if="currentPage === 2"
            class="mx-auto col-xl-9 col-lg-10 col-md-11 col-sm-12 d-flex flex-column card card-body blur shadow-blur"
          >
            <div
              class="card-body mb-0 pb-3"
              style="padding-top: 0.5rem"
            >
              <div class="row">
                <h5 class="mt-2">Line Layout</h5>
                <div class="d-flex justify-content-center">
                  <canvas
                    :id="LINE_LAYOUT_CANVAS_ID_BOTTOM"
                    class="col-12 mt-0 mb-4"
                    :width="CANVAS_WIDTH"
                    :height="CANVAS_HEIGHT"
                    :style="`max-width: 1280px;`"
                  >
                  </canvas>
                </div>
              </div>
              <div class="row">
                <div class="d-flex justify-content-center">
                  <div
                    class="table-responsive"
                    style="max-width: 1280px; width: 90%"
                  >
                    <table class="table table-sm text-center">
                      <thead>
                        <tr>
                          <th>Gun Name</th>
                          <th>New Gun Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="gun in reciprocators.side_bottom.guns"
                          :key="gun.gun_index"
                        >
                          <td>
                            {{ gun.name }}
                          </td>
                          <td>
                            <input
                              v-model="gun.gun_name_user_input"
                              type="text"
                              class="form-control form-control-sm mx-auto"
                              style="width: 50%"
                              @blur="checkGunNameLength(gun.gun_name_user_input)"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="col-12 d-flex justify-content-center mt-4">
                <button
                  type="button"
                  class="mt-4 mb-2 text-center btn"
                  :class="currentGunNamesFormUpdated ? 'bg-gradient-success' : 'bg-gradient-secondary'"
                  style="width: 50%"
                  @click="saveNewNames(reciprocators.side_bottom)"
                >
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import setTooltip from "@/assets/js/tooltip.js";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { nextTick } from "vue";

export default {
  name: "LineDetailSteelCase",
  components: {
    FontAwesomeIcon,
  },
  props: {
    lineId: {
      type: String,
      default: "",
    },
  },
  data() {
    this.$i18n.locale = this.$store.state.user_data.language;

    return {
      coating_booth: null,
      reciprocators: {},
      line_layout_images: {},
      currentPage: 0,
      CANVAS_WIDTH: 700,
      CANVAS_HEIGHT: 300,
      LINE_LAYOUT_CANVAS_ID_A: "lineLayoutCanvasA",
      LINE_LAYOUT_CANVAS_ID_B: "lineLayoutCanvasB",
      LINE_LAYOUT_CANVAS_ID_BOTTOM: "lineLayoutCanvasBottom",
    };
  },
  computed: {
    currentGunNamesFormUpdated() {
      let currentReciprocator = null;
      if (this.currentPage === 0) {
        currentReciprocator = this.reciprocators.side_A;
      } else if (this.currentPage === 1) {
        currentReciprocator = this.reciprocators.side_B;
      } else if (this.currentPage === 2) {
        currentReciprocator = this.reciprocators.side_bottom;
      }

      if (!currentReciprocator) {
        return false;
      }

      return this.checkAllFieldsFilled(currentReciprocator) && this.checkGunNamesChanged(currentReciprocator);
    },
  },
  watch: {
    currentPage() {
      this.fillLineLayoutCanvas();
    },
  },
  async mounted() {
    this.$store.state.isAbsolute = true;
    this.$store.commit("setLoading", true);
    setTooltip();
    await this.getData();
    this.$store.commit("setLoading", false);
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
  },
  methods: {
    async getData() {
      await this.getCoatingBooth();
      await this.getLineLayoutImages();
      this.fillLineLayoutCanvas();
    },

    async updateReciprocatorGunNames(reciprocator) {
      const gun_names_array = reciprocator.guns.map(gun => gun.gun_name_user_input || gun.name);
      await axios.patch(`/api/v1/fp/line/${reciprocator.id}/`, {
        gun_names: gun_names_array,
      });
    },

    checkAllFieldsFilled(reciprocator) {
      for (const gun of reciprocator.guns) {
        if (!gun.gun_name_user_input || gun.gun_name_user_input.trim() === "") {
          return false;
        }
      }
      return true;
    },

    checkGunNamesChanged(reciprocator) {
      for (const gun of reciprocator.guns) {
        if (gun.gun_name_user_input !== gun.name) {
          return true;
        }
      }
      return false;
    },
    checkGunNameLength(gun_name_user_input) {
      let max_length = 3;
      if (gun_name_user_input.length > max_length) {
        this.$swal({
          title: "Error",
          text: `Gun name should have a maximum of ${max_length} characters`,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    },
    async saveNewNames(reciprocator) {
      try {
        if (!this.checkAllFieldsFilled(reciprocator)) {
          await this.$swal({
            title: "Error",
            text: "Please fill all the fields",
            icon: "error",
            confirmButtonText: "OK",
          });
          return;
        }
        if (!this.checkGunNamesChanged(reciprocator)) {
          await this.$swal({
            title: "Warning",
            text: "No changes detected",
            icon: "warning",
            confirmButtonText: "OK",
          });
          return;
        }
        this.$store.commit("setLoading", true);

        await this.updateReciprocatorGunNames(reciprocator);
        await this.getData();

        this.$store.commit("setLoading", false);
        await this.$swal({
          title: "Changes saved",
          text: "New Gun names saved successfully",
          icon: "success",
          confirmButtonText: "OK",
        });
      } catch (error) {
        console.error(error);
      }
    },

    loadReciprocator(reciprocator) {
      if (reciprocator.guns) {
        // Sort guns by gun_index
        reciprocator.guns = reciprocator.guns.slice().sort((a, b) => a.gun_index - b.gun_index);
        reciprocator.guns.forEach(gun => {
          gun.gun_name_user_input = "";
        });
      }
      return reciprocator;
    },

    async getCoatingBooth() {
      try {
        const response = await axios.get("api/v1/steelcase/coatingbooth/" + this.lineId + "/");
        this.coating_booth = response.data;
        this.reciprocators = {
          side_A: this.loadReciprocator(this.coating_booth.reciprocator_side_A),
          side_B: this.loadReciprocator(this.coating_booth.reciprocator_side_B),
        };
        if (this.coating_booth.reciprocator_side_bottom) {
          this.reciprocators.side_bottom = this.loadReciprocator(this.coating_booth.reciprocator_side_bottom);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getLineLayoutImages() {
      try {
        var body = {
          line: this.reciprocators.side_A.id,
          canvas_width: this.CANVAS_WIDTH,
          canvas_height: this.CANVAS_HEIGHT,
          gun_names_overwrite: this.reciprocators.side_A.guns.map(gun => gun.name),
        };
        var response = await axios.post("/api/v1/fp/generatelinelayoutimage/", body);
        this.line_layout_images[this.LINE_LAYOUT_CANVAS_ID_A] = response.data["layout_image"];

        body = {
          line: this.reciprocators.side_B.id,
          canvas_width: this.CANVAS_WIDTH,
          canvas_height: this.CANVAS_HEIGHT,
          gun_names_overwrite: this.reciprocators.side_B.guns.map(gun => gun.name),
        };

        response = await axios.post("/api/v1/fp/generatelinelayoutimage/", body);
        this.line_layout_images[this.LINE_LAYOUT_CANVAS_ID_B] = response.data["layout_image"];

        if (this.reciprocators.side_bottom) {
          body = {
            line: this.reciprocators.side_bottom.id,
            canvas_width: this.CANVAS_WIDTH,
            canvas_height: this.CANVAS_HEIGHT,
            gun_names_overwrite: this.reciprocators.side_bottom.guns.map(gun => gun.name),
          };

          response = await axios.post("/api/v1/fp/generatelinelayoutimage/", body);
          this.line_layout_images[this.LINE_LAYOUT_CANVAS_ID_BOTTOM] = response.data["layout_image"];
        }
      } catch (error) {
        console.error(error);
      }
    },
    putImageDataForCanvas(canvasId) {
      const lineLayoutCanvas = document.getElementById(canvasId);
      const ctx = lineLayoutCanvas.getContext("2d");
      let imageData = new ImageData(
        Uint8ClampedArray.from(this.line_layout_images[canvasId].values()),
        this.CANVAS_WIDTH,
        this.CANVAS_HEIGHT,
      );
      ctx.putImageData(imageData, 0, 0);
    },
    fillLineLayoutCanvas() {
      nextTick(() => {
        if (this.currentPage === 0) {
          this.putImageDataForCanvas(this.LINE_LAYOUT_CANVAS_ID_A);
        } else if (this.currentPage === 1) {
          this.putImageDataForCanvas(this.LINE_LAYOUT_CANVAS_ID_B);
        } else if (this.currentPage === 2) {
          this.putImageDataForCanvas(this.LINE_LAYOUT_CANVAS_ID_BOTTOM);
        }
      });
    },
  },
};
</script>
<style scoped>
.table-sm th,
.table-sm td {
  padding: 0.3rem;
}

.table-bordered {
  border: 1px solid #dee2e6;
  border-collapse: collapse; /* Ensure borders are collapsed */
}

.table-bordered th,
.table-bordered td {
  border: 1px solid #dee2e6;
}

.table-border tbody tr:last-child td {
  border-width: 1px;
}

.container-fluid {
  padding-top: 20px;
}
</style>
